import Vue from 'vue';
import Vuex from 'vuex';

import api from '../api';
import navigation from './modules/navigation';
import laserUse from './modules/laseruse';
import application from './modules/application';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    language: 'NL',
    languageLowerCase: 'nl',
    languageList: [],
    text: {},
    errors: [],
    result: {},
    maxScore: 0,
    inputId: 0,
    emailFormData: {
      firstName: {
        value: '',
        error: '',
      },
      lastName: {
        value: '',
        error: '',
      },
      company: {
        value: '',
        error: '',
      },
      email: {
        value: '',
        error: '',
      },
      allowUse: {
        value: false,
      },
    },
    emailFormErrorCount: 0,
    emailFormWasSent: 0,
  },
  getters: {
    getLanguage: (state) => {
      return state.language;
    },
    getLanguageLowerCase: (state) => {
      return state.languageLowerCase;
    },
    getLanguageList: (state) => {
      return state.languageList;
    },
    getText: (state) => {
      return state.text;
    },
    getErrors: (state) => {
      return state.errors;
    },
    getResult: (state) => {
      return state.result;
    },
    getMaxScore: (state) => {
      return state.maxScore;
    },
    getInputId: (state) => {
      return state.inputId;
    },
    getEmailFormData: (state) => {
      return state.emailFormData;
    },
    getEmailFormErrorCount: (state) => {
      return state.emailFormErrorCount;
    },
    getEmailFormSentStatus: (state) => {
      return state.emailFormWasSent;
    },
  },
  mutations: {
    setLanguage: (state, payload) => {
      state.language = payload.language;
      state.languageLowerCase = payload.language.toLowerCase();
      state.text = payload.text;
    },
    fetchLanguages: (state, payload) => {
      state.languageList = payload;
    },
    setResult: (state, payload) => {
      state.result = payload;
    },
    setMaxScore: (state, payload) => {
      state.maxScore = payload;
    },
    setInputId: (state, payload) => {
      state.inputId = payload;
    },
    setEmailFormData: (state, payload) => {
      state.emailFormData[payload.field].value = payload.value;
    },
    setEmailFormError: (state, payload) => {
      state.emailFormData[payload.field].error = payload.error;
    },
    resetEmailFormErrorCount: (state) => {
      state.emailFormErrorCount = 0;
    },
    incrementEmailFormErrorCount: (state) => {
      state.emailFormErrorCount += 1;
    },
    setEmailFormSentStatus: (state, payload) => {
      state.emailFormWasSent = payload;
    },
    setError: (state, payload) => {
      const index = (state.errors.indexOf(payload));
      if (index === -1) {
        state.errors.push(payload);
      }
    },
    removeError: (state, payload) => {
      const index = (state.errors.indexOf(payload));
      if (index > -1) {
        state.errors.splice(index, 1);
      }
    },
  },
  actions: {
    setLanguage: ({ commit }, language) => {
      api.getDbText(language)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          const resultObject = {};
          for (const key in data) {
            resultObject[data[key].txid] = data[key].text;
          }
          commit('setLanguage', {
            language,
            text: resultObject,
          });
        });
    },
    fetchLanguages: ({ commit }) => {
      api.getDbLanguageList()
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          const resultArray = [];
          for (const key in data) {
            resultArray[key] = data[key];
          }
          commit('fetchLanguages', resultArray);
        });
    },
    fetchResult: ({ commit }, payload) => {
      api.getLaserResult(payload)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          commit('setResult', data.data);
          commit('setMaxScore', data.maxScore);
          commit('setInputId', data.inputId);
        });
    },
    setEmailFormData: ({ commit }, payload) => {
      commit('setEmailFormData', payload);
    },
    evaluateFormField: (context, payload) => {
      if (context.rootGetters.getEmailFormData[payload.field].value === '') {
        const errorMessage = { field: payload.field, error: payload.error };
        context.commit('setEmailFormError', errorMessage);
        context.commit('incrementEmailFormErrorCount');
      } else {
        const errorMessage = { field: payload.field, error: '' };
        context.commit('setEmailFormError', errorMessage);
      }
    },
    submitEmailForm: (context) => {
      context.commit('resetEmailFormErrorCount');
      const lastName = { field: 'lastName', error: context.rootState.text['0030'] };
      context.dispatch('evaluateFormField', lastName);
      const firstName = { field: 'firstName', error: context.rootState.text['0030'] };
      context.dispatch('evaluateFormField', firstName);
      const companyError = { field: 'company', error: context.rootState.text['0030'] };
      context.dispatch('evaluateFormField', companyError);
      const emailError = { field: 'email', error: context.rootState.text['0031'] };
      context.dispatch('evaluateFormField', emailError);
      if (context.rootGetters.getEmailFormErrorCount === 0) {
        context.dispatch('sendResultEmail');
      }
    },
    sendResultEmail: (context) => {
      const input = {
        inputId: context.rootGetters.getInputId,
        formData: context.rootGetters.getEmailFormData,
      };
      api.sendResultEmail(input)
        .then((response) => {
          context.commit('setEmailFormSentStatus', 1);
          console.log(response);
        });
    },
  },
  modules: {
    navigation,
    laserUse,
    application,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js